module.exports = __webpack_public_path__ + "static/media/work-731198_1920.0db2172a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/work-731198_1920.png
// module id = 73
// module chunks = 0